import { environment } from '../../environments/environment';

/**
 * localStorage key holding the code that unlocked the app. Same key as the charge-plus-web
 * PinGuard, and the same behaviour: unlocked once per browser, survives reloads and restarts
 * until localStorage is cleared.
 */
export const PIN_GATE_STORAGE_KEY = 'pin';

/** Shared access code. Only ever asked for where `environment.pinGuardActivated` is true. */
export const PIN_GATE_CODE = '1989';

/**
 * True when the app must show the access-code screen instead of booting.
 *
 * Called from `main.ts` *before* `bootstrapApplication`, so a locked environment runs no app
 * initializer at all: no `/me` call, no token exchange, no redirect to EntraID, nothing of the
 * application rendered. That is what makes this a real gate rather than a route guard.
 */
export function isPinGateLocked(): boolean {
  return environment.pinGuardActivated && readStoredCode() !== PIN_GATE_CODE;
}

/** Persists the code so this boot and every later one go straight to the app. */
export function unlockPinGate(): void {
  try {
    localStorage.setItem(PIN_GATE_STORAGE_KEY, PIN_GATE_CODE);
  } catch (_error) {
    // Storage unavailable (private mode / blocked cookies). Nothing to do: the app stores its
    // bearer token there too, so it could not work anyway — the gate will just ask again.
    return;
  }
}

function readStoredCode(): string | null {
  try {
    return localStorage.getItem(PIN_GATE_STORAGE_KEY);
  } catch (_error) {
    // Storage unavailable — stay locked rather than break the boot.
    return null;
  }
}
